import styled from 'styled-components';

const Search = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
  width: 100%;

  input {
    padding: 0.9rem 1.15rem;
    width: 30%;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    outline: none;
    border: none;
    font-family: 'Economica', sans-serif;
    font-size: 1rem;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    color: rgb(197, 197, 197);
    transition: all 0.5s ease-in-out;
    font-weight: bold;
    transition: all 0.5s ease-in-out;

    @media only screen and (max-width: 600px) {
      width: 70%;
    }

    @media only screen and (max-width: 400px) {
      width: 80%;
    }
  }

  ul {
    width: 30%;
    padding: 0.9rem 1.15rem;
    background-color: white;
    max-height: 60%;
    overflow-y: auto;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    list-style-type: none;
    text-align: left;
    margin-top: 0;
    margin-bottom: 1rem;
    border-width: 1px 1px 1px;
    border-style: none solid solid;
    border: none;
    border-color: rgb(187, 187, 187) rgb(187, 187, 187) rgb(187, 187, 187);
    border-image: initial;
    border-top: none;

    @media only screen and (max-width: 600px) {
      width: 70%;
    }

    @media only screen and (max-width: 400px) {
      width: 80%;
    }

    li {
      width: 100%;
      cursor: pointer;
      padding: 0.75rem 0.3rem;
      border: none;
      outline: none;

      &:hover {
        background-color: #40474c;
        color: white;
      }
    }
  }
`;

export default Search;
